import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { AuthenticationCredentialsResult, AuthenticationCredentialsParams } from "./types";

export const getAuthenticationCredentials = reactQueryTableFetcherAdapter(
  "/app_settings/authentication_credentials",
  (
    signal: AbortSignal,
    { appGroupId, surface, query, limit = 100, start = 0, sortby, sortdir }: AuthenticationCredentialsParams
  ): Promise<AuthenticationCredentialsResult> =>
    fetch(
      "/app_settings/authentication_credentials",
      "GET",
      {
        app_group_id: appGroupId,
        surface,
        limit,
        start,
        sortby,
        sortdir,
        query: serializeQueryObjects(query ?? {}),
      },
      { signal },
      { propagateFetchRequestError: false }
    )
);
